import * as React from 'react';

import type { InvoicesFilterContextValue } from './InvoicesFilterContext.types';

import { InvoicesFilterContext } from './InvoicesFilterProvider';

export function useInvoicesFilter(): InvoicesFilterContextValue {
  const context = React.useContext(InvoicesFilterContext);

  if (!context) {
    throw new Error(
      'useInvoicesFilter must be used within InvoicesFilterProvider'
    );
  }

  return context;
}
